define('viewmodels/survey',['plugins/router', 'knockout', 'services/appsecurity', 'services/navigation','services/logger','durandal/app'], function (router, ko, appsecurity, navigation,logger,app) {
    var childRouter = router.createChildRouter()
           .makeRelative({
               //moduleId: 'viewmodels',
               fromParent: true
           }).map([
               //{ route: ['', 'questionnaire'], moduleId: 'viewmodels/survey/questionnaire', title: 'Questionnaire', type: 'survey', hash: '#survey/questionnaire', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               //{ route: 'questions', moduleId: 'viewmodels/survey/questions', title: 'Questions', type: 'survey', hash: '#survey/questions', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               //{ route: 'assignment', moduleId: 'viewmodels/survey/assignment', title: 'Assignment', hash: '#survey/assignment', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               //CreateSurvey Screen Route
               { route: ['','CreateSurvey'], moduleId: 'viewmodels/survey/CreateSurvey', title: 'Create Survey', hash: '#survey/CreateSurvey', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               { route: ['SurveyAssignment'], moduleId: 'viewmodels/survey/SurveyAssignment', title: 'Survey Assignment', hash: '#survey/SurveyAssignment', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               { route: ['ConfigureSurvey'], moduleId: 'viewmodels/survey/ConfigureSurvey', title: 'Survey Configuration', hash: '#survey/ConfigureSurvey', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               { route: ['ResponsibilityGroup'], moduleId: 'viewmodels/survey/ResponsibilityGroup', title: 'Responsibility Group Management', hash: '#survey/ResponsibilityGroup', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               { route: ['WorkflowConfigure'], moduleId: 'viewmodels/survey/WorkflowConfigure', title: 'Workflow Setup', hash: '#survey/WorkflowConfigure', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               { route: ['BlueprintSetup'], moduleId: 'viewmodels/survey/BlueprintSetup', title: 'Blueprint Setup', hash: '#survey/BlueprintSetup', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               //AMLControlAreaSetup Screen Route
               { route: 'AMLControlAreaSetup', moduleId: 'viewmodels/survey/AMLControlAreaSetup', title: 'AML Control Area Setup', hash: '#survey/AMLControlAreaSetup', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               //SurveyTracking
               { route: 'SurveyTracking', moduleId: 'viewmodels/survey/SurveyTracking', title: 'Survey Tracking', hash: '#survey/SurveyTracking', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },
               { route: 'SurveyDashBoard', moduleId: 'viewmodels/survey/SurveyDashBoard', title: 'Survey DashBoard', hash: '#survey/SurveyDashBoard', type: 'survey', nav: true, settings: { caption: 'fa fa-list-alt', another: 'property' } },

           ]).buildNavigationModel();

    return {
        navigation: navigation,
        router: childRouter,
        activate: activate,
        attached: attached,
        detached:detached,
        navigateQuestionnaire: navigateQuestionnaire,
        navigateQuestions: navigateQuestions,
        navigateAssignment:navigateAssignment,
        logger: logger,
        //code edited
        appsecurity: appsecurity,

        //code edited
        surveyOptions: ko.computed(function () {
            return ko.utils.arrayFilter(childRouter.navigationModel(), function (route) {
                return route.type == 'survey';
            });
        })

    };

    function activate() {

    }

    function attached() {
        $($(document.getElementsByClassName('list-group-item')).get(0)).addClass('active');
        $($(document.getElementsByClassName('list-group-item')).get(4)).css({ "display": "none" });
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(3)).addClass('active')


    }
    function detached() {
        $($(document.getElementsByClassName('list-group-item')).get(0)).removeClass('active');
        $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(3)).removeClass('active')
    }

    function navigateQuestionnaire() {
        try {
            router.navigate("survey/questionnaire", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateQuestionnaire() Landing.js';
            logger.logMessage(msg);
        }
    }

    function navigateQuestions() {
        try {
            router.navigate("survey/questions", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateQuestions() Landing.js';
            logger.logMessage(msg);
        }
    }

    function navigateAssignment() {
        try {
            router.navigate("survey/assignment", true);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: navigateAssignment() Landing.js';
            logger.logMessage(msg);
        }
    }
});
